<template>
  <div>
    <div class="grid-content maintitle">
      <span>{{ $t("message.产品分类编辑") }}</span>
    </div>
    <div class="topContainer">
      <div class="grid-content content-margin topFix">
        <div class="buttonarea">
          <el-link :underline="false">
            <el-button size="medium" round @click.native="goBack">
              <i class="iconfont">&#xe600;</i>
              {{ $t("message.返回") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="!isEditMode && !isInit">
            <el-button size="medium" round @click="isEditMode = true">
              <i class="iconfont">&#xe618;</i>
              {{ $t("message.修改") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="isEditMode">
            <el-button size="medium" round @click="doSave" type="primary">
              <i class="iconfont">&#xe769;</i>
              {{ $t("message.保存") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="!isInit">
            <el-button size="medium" round @click.native="refresh">
              <i class="iconfont">&#xe667;</i>
              {{ $t("message.刷新") }}
            </el-button>
          </el-link>
        </div>
        <!-- <el-divider></el-divider> -->
      </div>
    </div>
    <div class="grid-content subtitle">
      <span>{{ $t("message.分类主信息") }}</span>
    </div>
    <div class="grid-content content-margin">
      <table class="simpleRow">
        <tr v-if="classifyid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.分类ID") }}</span>
          </td>
          <td>
            <el-input v-model="classifyid" readonly size="mini" placeholder="">
            </el-input>
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">*分类名称</span>
          </td>
          <td>
            <el-input
              :readonly="!isEditMode"
              v-model="name"
              size="mini"
              maxlength="10"
              :placeholder="$t('message.输入10个以内汉字')"
            />
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.批次标签") }}</span>
          </td>
          <td>
            <el-input
              :readonly="!isEditMode"
              v-model="batchtag"
              size="mini"
              maxlength="10"
              :placeholder="$t('message.输入10个以内汉字')"
            />
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.归属") }}</span>
          </td>
          <td>
            <el-radio-group :disabled="!isEditMode" v-model="belong">
              <el-radio :label="0">{{ $t("message.普通分类") }}</el-radio>
              <el-radio :label="1">{{ $t("message.积分商城分类") }}</el-radio>
            </el-radio-group>
            <!-- <el-switch
              :disabled="!isEditMode"
              v-model="belong"
              :active-text="$t('message.是')"
              :inactive-text="$t('message.否')"
            ></el-switch> -->
          </td>
        </tr>
        <tr>
                    <td>
                        <span class="simpleLabel">{{ $t("message.领取方式") }}</span>
                    </td>
                    <td>
                        <el-checkbox-group :disabled="!isEditMode" v-model="receivetype">
                            <el-checkbox v-for="item in classifyPostState" :label="item.value" :key="item.key">
                                {{item.key}}
                            </el-checkbox>
                        </el-checkbox-group>
                    </td>
                </tr>
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.状态") }}</span>
          </td>
          <td>
            <el-radio-group :disabled="!isEditMode" v-model="state">
              <el-radio :label="0">{{ $t("message.正常") }}</el-radio>
              <!-- <el-radio :label="1">{{ $t("message.纯占位 ") }}</el-radio>
              <el-radio :label="2">{{ $t("message.已删除 ") }}</el-radio> -->
              <el-radio :label="3">{{ $t("message.测试用") }}</el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.秒杀栏位") }}</span>
          </td>
          <td>
            <el-radio-group :disabled="!isEditMode" v-model="isseckill">
              <!-- <el-radio :label="0">{{ $t("message.否") }}</el-radio>
              <el-radio :label="1">{{ $t("message.是") }}</el-radio> -->
              <el-switch
              :disabled="!isEditMode"
              v-model="isseckill"
              :active-text="$t('message.是')"
              :inactive-text="$t('message.否')"
            ></el-switch>
            </el-radio-group>
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.类型") }}</span>
          </td>
          <td>
            <el-select
              size="small"
              v-model="type"
              :disabled='!isEditMode'
              :placeholder="$t('message.请选择')"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              >
              </el-option>
            </el-select>
          </td>
          <td></td>
          <td>
            <tr v-if="type == '2'">
              <td>
                <span class="simpleLabel">{{ $t("message.品牌") }}</span>
              </td>
              <td>
                <el-select
                  size="small"
                  v-model="brandid"
                  :placeholder="$t('message.请选择')"
                  clearable
                >
                  <el-option
                    v-for="item in brandOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled"
                  >
                  </el-option>
                </el-select>
              </td>
            </tr>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.LOGO图片") }}</span>
          </td>
          <td>
            <!-- 图片库控件 -->
            <div
              :class="!isEditMode ? 'unsel-img-box' : 'sel-img-box'"
              @click="doShowResourceStore(1)"
            >
              <i class="iconfont" v-if="!img">&#xe727;</i>
              <el-popover placement="right" trigger="hover" v-else>
                <img
                  :src="'' + img"
                  alt=""
                  style="max-width: 500px; max-height: 500px"
                />
                <img slot="reference" :src="'' + img" />
                <el-button
                  v-if="isEditMode"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  @click.native="img = ''"
                ></el-button>
              </el-popover>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.是否列表显示") }}</span>
          </td>
          <td>
            <el-switch
              :disabled="!isEditMode"
              v-model="isShowSwitch"
              :active-text="$t('message.是')"
              :inactive-text="$t('message.否')"
            ></el-switch>
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.优先级排序") }}</span>
          </td>
          <td>
            <el-input-number
              :min="0"
              :disabled="!isEditMode"

              size="mini"
              v-model="sort"
            ></el-input-number>
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">上级分类</span>
          </td>
          <td>
            <el-select
              size="small"
              v-model="parentname"
              placeholder="请选择"
              :disabled='!isEditMode'
              clearable
              @clear='clearparentid'
              @change="ParentSelect"
            >
              <el-option
                v-for="(item,index) in classifyOptions"
                :key="index"
                :label="item.label"
                :value="index"
                :disabled="item.disabled"
              >
              </el-option>
            </el-select>
          </td>
        </tr>
        <!-- <tr>
            <td>
              <span class="simpleLabel">结构继承分类</span>
            </td>
            <td>
              <el-select size="small" v-model="extendid" placeholder="请选择" clearable>
                  <el-option
                    v-for="item in classifyOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled">
                  </el-option>
                </el-select>
            </td>
          </tr> -->
        <tr v-if="classifyid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.创建日期") }}</span>
          </td>
          <td>
            <el-input
              readonly
              v-model="createdate"
              size="mini"
              placeholder=""
            />
          </td>
        </tr>
        <tr v-if="classifyid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.创建人") }}</span>
          </td>
          <td>
            <el-input readonly  size="mini" :placeholder="idtoname(createid)" />
          </td>
        </tr>
        <tr v-if="classifyid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.更新日期") }}</span>
          </td>
          <td>
            <el-input readonly v-model="editdate" size="mini" placeholder="" />
          </td>
        </tr>
        <tr v-if="classifyid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.更新人") }}</span>
          </td>
          <td>
            <el-input readonly  size="mini" :placeholder="idtoname(editid)" />
            
          </td>
        </tr>
      </table>
    </div>
    <div class="grid-content subtitle">
      <span>{{ $t("message.分类轮播图") }}</span>
    </div>
    <div class="grid-content content-margin">
      <div class="buttonarea">
        <el-link :underline="false">
          <el-button
            :disabled="!isEditMode"
            size="medium"
            round
            @click.native="createCarouseTarget"
          >
            <i class="iconfont">&#xe727;</i>
            {{ $t("message.添加") }}
          </el-button>
        </el-link>
      </div>
    </div>
    <div class="grid-content content-margin">
      <el-table
        ref="table"
        :data="tableDataCarouse"
        stripe
        border
        :max-height="tableHeight"
        style="width: 100%"
      >
        <el-table-column fixed label="No." type="index" width="55">
        </el-table-column>
        <el-table-column
          fixed
          width="160"
          :label="$t('message.操作')"
          align="center"
        >
          <template slot-scope="scope">
            <el-button-group>
              <el-button
                size="mini"
                v-if="!isEditMode"
                round
                type="normal"
                icon="el-icon-zoom-in"
                @click="editCarouseTarget(scope.row, false)"
              ></el-button>
              <el-button
                size="mini"
                v-else
                round
                type="normal"
                icon="el-icon-edit"
                @click="editCarouseTarget(scope.row, true)"
              ></el-button>
              <el-button
                size="mini"
                :disabled="!isEditMode"
                round
                type="normal"
                icon="el-icon-delete"
                @click="
                  targetRow = scope.row;
                  deleteType = 1;
                  deleteDialogVisible = true;
                "
              ></el-button>
            </el-button-group>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('message.轮播图片')"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.img != ''"
              placement="top-start"
              title=""
              trigger="hover"
            >
              <img
                :src="'' + scope.row.img"
                alt=""
                style="max-width: 500px; max-height: 500px"
              />
              <img
                slot="reference"
                :src="'' + scope.row.img"
                style="max-width: 120px; max-height: 30px"
              />
            </el-popover>
            <span v-else>{{ $t("message.无") }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="200"
          sortable
          prop="jumpurl"
          :label="$t('message.跳转链接')"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="sort"
          :label="$t('message.排序')"
          min-width="150"
        >
        </el-table-column>
        <el-table-column
          sortable
          :label="$t('message.是否列表显示')"
          min-width="150"
        >
          <template slot-scope="scope">
            <span>{{ $t(`message.${getBooleanName(scope.row.isshow)}`) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="type == '0'">
      <div class="grid-content subtitle">
        <span>3.分类下的子分类管理</span>
      </div>
      <div class="grid-content content-margin">
        <el-link :underline="false">
          <el-button
            :disabled="!isEditMode"
            size="medium"
            round
            @click.native="addclassifyfunc"
          >
            <i class="iconfont">&#xe727;</i>
            {{ $t("message.添加") }}
          </el-button>
        </el-link>
        <div style="height:20px"></div>
        <el-table
          ref="table"
          :data="filterData2"
          stripe
          border
          :max-height="tableHeight"
          style="width: 100%"
        >
          <el-table-column fixed label="No." type="index" width="55">
          </el-table-column>
          <el-table-column
            fixed
            width="240"
            :label="$t('message.操作')"
            align="center"
          >
            <template slot-scope="scope">
              <el-button-group>
                <el-button
                  :disabled="!isEditMode"
                  size="mini"
                  round
                  type="normal"
                  icon="el-icon-top"
                  @click="toTop(scope.row)"
                ></el-button>
                <el-button
                  :disabled="!isEditMode"
                  size="mini"
                  round
                  type="normal"
                  icon="el-icon-sort-up"
                  @click="toUp(scope.row)"
                ></el-button>
                <el-button
                  :disabled="!isEditMode"
                  size="mini"
                  round
                  type="normal"
                  icon="el-icon-sort-down"
                  @click="toDown(scope.row)"
                ></el-button>
                <el-button
                  :disabled="!isEditMode"
                  size="mini"
                  round
                  type="normal"
                  icon="el-icon-bottom"
                  @click="toBottom(scope.row)"
                ></el-button>
                <el-button
                  :disabled="!isEditMode"
                  size="mini"
                  round
                  type="normal"
                  icon="el-icon-delete"
                  @click="
                    targetRow = scope.row;
                    deleteType = 3;
                    deleteDialogVisible = true;
                  "
                ></el-button>
              </el-button-group>
            </template>
          </el-table-column>
          <el-table-column
            prop="classifyid"
            :label="$t('message.分类ID')"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            :label="$t('message.分类名称')"
            min-width="150"
          >
          </el-table-column>
          <el-table-column
            prop="type"
            :label="$t('message.类型')"
            min-width="150"
          >
            <template slot-scope="scope">
              <span>{{
                $t(`message.${getClassifyTypeName(scope.row.type)}`)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('message.LOGO图片')"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <el-popover
                v-if="scope.row.img != ''"
                placement="top-start"
                title=""
                trigger="hover"
              >
                <img
                  :src="'' + scope.row.img"
                  alt=""
                  style="max-width: 500px; max-height: 500px"
                />
                <img
                  slot="reference"
                  :src="'' + scope.row.img"
                  style="max-width: 120px; max-height: 30px"
                />
              </el-popover>
              <span v-else>{{ $t("message.无") }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="extendid"
            :label="$t('message.继承分类ID')"
            min-width="150"
          >
          </el-table-column>
          <el-table-column
            width="150"
            prop="isshow"
            :label="$t('message.是否列表显示')"
          >
            <template slot-scope="scope">
              <span>{{
                $t(`message.${getBooleanName(scope.row.isshow)}`)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="editdate"
            :label="$t('message.更新日期')"
            min-width="160"
          >
          </el-table-column>
          <el-table-column
            prop="editid"
            :label="$t('message.更新人')"
            min-width="150"
          >
          <template slot-scope="scope">
                {{
                idtoname(scope.row.editid)
                }}
                </template>
          </el-table-column>
          <el-table-column
            prop="sort"
            :label="$t('message.排序')"
            min-width="150"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div v-if="type == '1'">
      <div class="grid-content subtitle">
        <span>{{ $t("message.分类下的产品管理") }}</span>
      </div>
      <div class="grid-content content-margin">
        <table class="simpleRow">
          <tr>
            <td>
              <el-link :underline="false">
                <el-button
                  :disabled="!isEditMode"
                  size="medium"
                  round
                  @click.native="addProduct"
                >
                  <i class="iconfont">&#xe727;</i>
                  {{ $t("message.添加") }}
                </el-button>
              </el-link>
            </td>
            <td style="padding-left: 20px">
              <span class="simpleLabel">{{ $t("message.筛选") }}</span>
            </td>
            <td>
              <el-input
                clearable
                prefix-icon="el-icon-search"
                v-model="search"
                size="small"
                :placeholder="$t('message.输入关键字')"
              />
            </td>
            <td style="padding-left: 20px">
              <span class="simpleLabel">{{ $t("message.品牌") }}</span>
            </td>
            <td>
              <el-select
                size="small"
                v-model="selectedBrandID"
                :placeholder="$t('message.请选择')"
                clearable
              >
                <el-option
                  v-for="item in brandOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
                >
                </el-option>
              </el-select>
            </td>
          </tr>
        </table>
      </div>
      <div class="grid-content content-margin">
        <el-table
          ref="table"
          :data="filterData"
          stripe
          border
          :max-height="tableHeight"
          style="width: 100%"
        >
          <el-table-column fixed label="No." type="index" width="55">
          </el-table-column>
          <el-table-column
            fixed
            width="240"
            :label="$t('message.操作')"
            align="center"
          >
            <template slot-scope="scope">
              <el-button-group>
                <el-button
                  :disabled="!isEditMode"
                  size="mini"
                  round
                  type="normal"
                  icon="el-icon-top"
                  @click="toTop(scope.row)"
                ></el-button>
                <el-button
                  :disabled="!isEditMode"
                  size="mini"
                  round
                  type="normal"
                  icon="el-icon-sort-up"
                  @click="toUp(scope.row)"
                ></el-button>
                <el-button
                  :disabled="!isEditMode"
                  size="mini"
                  round
                  type="normal"
                  icon="el-icon-sort-down"
                  @click="toDown(scope.row)"
                ></el-button>
                <el-button
                  :disabled="!isEditMode"
                  size="mini"
                  round
                  type="normal"
                  icon="el-icon-bottom"
                  @click="toBottom(scope.row)"
                ></el-button>
                <el-button
                  :disabled="!isEditMode"
                  size="mini"
                  round
                  type="normal"
                  icon="el-icon-delete"
                  @click="
                    targetRow = scope.row;
                    deleteType = 2;
                    deleteDialogVisible = true;
                  "
                ></el-button>
              </el-button-group>
            </template>
          </el-table-column>

          <el-table-column
            sortable
            prop="shelvesid"
            :label="$t('message.产品ID')"
            width="150"
          >
          </el-table-column>
          <el-table-column
            sortable
            prop="name"
            :label="$t('message.产品名称')"
            min-width="150"
          >
          </el-table-column>
          <el-table-column
            sortable
            :label="$t('message.品牌名称')"
            min-width="150"
          >
            <template slot-scope="scope">
              <span>{{ getBrandName(scope.row.brandid) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('message.产品图片')"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <el-popover
                v-if="scope.row.img != ''"
                placement="top-start"
                title=""
                trigger="hover"
              >
                <img
                  :src="'' + scope.row.img"
                  alt=""
                  style="max-width: 500px; max-height: 500px"
                />
                <img
                  slot="reference"
                  :src="'' + scope.row.img"
                  style="max-width: 120px; max-height: 30px"
                />
              </el-popover>
              <span v-else>{{ $t("message.无") }}</span>
            </template>
          </el-table-column>
          <el-table-column
            sortable
            prop="shelvesinfo"
            label="c"
            min-width="200"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            min-width="200"
            sortable
            prop="jumpurl"
            :label="$t('message.跳转链接')"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column width="150" sortable :label="$t('message.产品状态')">
            <template slot-scope="scope">
              <span>{{
                $t(`message.${getProductStateName(scope.row.state)}`)
              }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-drawer
      :show-close="false"
      :size="800"
      :visible.sync="showDateilDrawer"
      :direction="'rtl'"
      :before-close="handleClose"
    >
      <div class="grid-content subtitle">
        <span>{{ $t("message.轮播图管理sel") }}</span>
      </div>
      <div class="grid-content content-margin">
        <div class="buttonarea">
          <el-link :underline="false">
            <el-button
              size="medium"
              round
              @click.native="showDateilDrawer = false"
            >
              <i class="iconfont">&#xe600;</i>
              {{ $t("message.返回") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="isEditMode">
            <el-button size="medium" round @click="doSaveDetail">
              <i class="iconfont">&#xe769;</i>
              {{ $t("message.确定") }}
            </el-button>
          </el-link>
        </div>
        <el-divider></el-divider>
      </div>
      <div class="grid-content content-margin">
        <table class="simpleRow">
          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.图片") }}</span>
            </td>
            <td>
              <!-- 图片库控件 -->
              <div class="sel-img-box" @click="doShowResourceStore(2)">
                <i class="iconfont" v-if="!d_img">&#xe727;</i>
                <el-popover placement="right" trigger="hover" v-else>
                  <img
                    :src="'' + d_img"
                    alt=""
                    style="max-width: 500px; max-height: 500px"
                  />
                  <img
                    slot="reference"
                    :src="'' + d_img"
                  />
                  <el-button
                    v-if="isEditMode"
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    @click.native="d_img = ''"
                  ></el-button>
                </el-popover>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.跳转链接") }}</span>
            </td>
            <td>
              <el-input
                :readonly="!isEditMode"
                size="mini"
                class="linkTextArea"
                v-model="d_jumpurl"
                type="textarea"
                :placeholder="$t('message.请输入链接')"
                maxlength="2000"
                show-word-limit
                width="300px"
              >
              </el-input>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.是否显示") }}</span>
            </td>
            <td>
              <el-switch
                :disabled="!isEditMode"
                v-model="d_isShowSwitch"
                :active-text="$t('message.是')"
                :inactive-text="$t('message.否')"
              ></el-switch>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.优先级排序") }}</span>
            </td>
            <td>
              <el-input-number
                :min="0"
                :disabled="!isEditMode"
                size="mini"
                v-model="d_sort"
              ></el-input-number>
            </td>
          </tr>
        </table>
      </div>
    </el-drawer>
    <el-dialog
      :title="$t('message.删除确认')"
      :visible.sync="deleteDialogVisible"
      width="300px"
      :modal="false"
      center
      :before-close="handleClose"
    >
      <i class="iconfont">&#xe766;</i>
      <span>{{ $t("message.请确认是否删除该内容") }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">{{
          $t("message.取消")
        }}</el-button>
        <el-button type="primary" @click.native="deleteTarget">{{
          $t("message.删除")
        }}</el-button>
      </span>
    </el-dialog>
    <shade v-if="showResourceStore > 0">
      <resource-store
        :shadeShow="showResourceStore > 0"
        @onClick="onResourceStoreCallback"
        :appID="appid"
      ></resource-store>
    </shade>
    <shade v-if="showShelvesStore > 0">
      <shelves-store
        v-bind:ismulti="ismulti"
        v-bind:excludeList="tableData"
        :key="timer"
        @onClick="onStoreClick"
      ></shelves-store>
    </shade>
    <modalreal
      :zIndexEdit="true"
      :width="1050"
      :height="680"
      v-if="displayclassify"
    >
      <div slot="title">
        编辑特定设置
      </div>
      <div slot="serch">
          <div class="serch-box">
            <el-input
              clearable
              prefix-icon="el-icon-search"
              v-model="search"
              @change="refresh2"
              :placeholder="$t('message.请输入搜索内容')"/>
          </div>
      </div>
      <div style="flex: 1" slot="contner" v-if="pagechangeshow">
        <div class="grid-content content-margin">
          <template>
            <el-table
              ref="multipleTable"
              :data="tableData2"
              tooltip-effect="dark"
              :row-key='keyIndex'
              stripe
              border
              @sort-change="filterFunc"
              style="width: 100%"
              :height="tableHeight"
              @selection-change="handleSelectionChange"
              size="mini"
            >
              <el-table-column
                type="selection"
                :selectable='isselected'
                :reserve-selection='true'
                width="55">
              </el-table-column>
              <el-table-column
                fixed
                label="No."
                type="index"
                :index="indexm"
                width="55"
              >
              </el-table-column>
              <el-table-column
                prop="classifyid"
                :label="$t('message.分类ID')"
                width="150"
              >
              </el-table-column>
              <el-table-column
                prop="name"
                :label="$t('message.分类名称')"
                min-width="150"
              >
              </el-table-column>
              <el-table-column
                sortable
                prop="type"
                :label="$t('message.类型')"
                min-width="150"
              >
                <template slot-scope="scope">
                  <span>{{
                    $t(`message.${getClassifyTypeName(scope.row.type)}`)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('message.LOGO图片')"
                width="150"
                align="center"
              >
                <template slot-scope="scope">
                  <el-popover
                    v-if="scope.row.img != ''"
                    placement="top-start"
                    title=""
                    trigger="hover"
                  >
                    <img
                      :src="'' + scope.row.img"
                      alt=""
                      style="max-width: 500px; max-height: 500px"
                    />
                    <img
                      slot="reference"
                      :src="'' + scope.row.img"
                      style="max-width: 120px; max-height: 30px"
                    />
                  </el-popover>
                  <span v-else>{{ $t("message.无") }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="parentid"
                :label="$t('message.父分类ID')"
                min-width="150"
              >
              </el-table-column>
              <el-table-column
                prop="extendid"
                :label="$t('message.继承分类ID')"
                min-width="150"
              >
              </el-table-column>
              <el-table-column
                width="150"
                prop="isshow"
                sortable
                :label="$t('message.是否列表显示')"
              >
                <template slot-scope="scope">
                  <span>{{
                    $t(`message.${getBooleanName(scope.row.isshow)}`)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="editdate"
                :label="$t('message.更新日期')"
                min-width="160"
              >
              </el-table-column>
              <el-table-column
                prop="editid"
                :label="$t('message.更新人')"
                min-width="150"
              >
              <template slot-scope="scope">
                {{
                idtoname(scope.row.editid)
                }}
                </template>
              </el-table-column>
              <el-table-column
                prop="sort"
                :label="$t('message.排序')"
                min-width="150"
              >
              </el-table-column>
            </el-table>
          </template>
        </div>
      </div>
      <div class="footer" slot="foter">
        <!-- <el-button @click="cancel(0)" size="mini">取消</el-button>
        <el-button @click="save(0)" type="primary" size="mini">保存</el-button> -->
        <div class="flex-b">
          <div class="myObject">
            {{ tableData2.length }} / {{ this.pageConfig.total +$t('message.个项目')}} 
          </div>
          <div>
            <!-- 放置分页组件区域 -->
            <pagination :pagesizeList='pageConfig.pagesizeList' :pagesize='sendData.pageConfig.pagesize' :total='pageConfig.total' :page='sendData.pageConfig.page' unsize='prev, pager, next' color='#f3f3f3'></pagination>
          </div>
          <div class="on-btn">
            <el-button type="" size="mini" @click="refresh2" icon="el-icon-refresh" round
              >{{$t('message.刷新')}}</el-button
            >
            <el-button type="" size="mini" @click="onButtonClick(0)" icon="el-icon-close" round
              >{{$t('message.关闭')}}</el-button
            >
            <el-button type="primary" size="mini" @click="onButtonClick(1)" icon="el-icon-check" round
              >{{$t('message.选择')}}</el-button
            >
          </div>
        </div>
      </div>
    </modalreal>
    
  </div>
</template>

<script>
import commonUtil from "@/utils/commonUtil";
import { topfixfunc } from "@/utils/topFix";
import ResourceStore from "@/components/resourceStore/resourceStore";
import shelvesStore from "@/components/productStore/shelvesStore";
import shade from "@/components/shade/shade";
import { rejecthttp, changeflagCLOSED } from "@/utils/request";
import modalreal from "@/components/modalCom/modalreal";
// 分页模块
import pagination from "@/components/pagination/pagination";

  import { pushdata,idtoname } from '@/utils/minxins'

export default {
  name: "BrandTypeDetail",
  components: {
    shade,
    ResourceStore,
    shelvesStore,
    modalreal,
    pagination
  },
  data() {
    return {
    classifyPostState:[
                {
                    key:'邮寄',
                    value:1
                },
                {
                    key:'自提',
                    value:2
                }
            ],
            receivetype:[1,2],
      idtoname:idtoname,
      appid: 0,
      tableHeight: 900,
      ismulti: true,
      typeOptions: [
        {
          value: "0",
          label: this.$t("message.父菜单容器型"),
        },
        {
          value: "1",
          label: this.$t("message.商品列表型"),
        },
        {
          value: "2",
          label: this.$t("message.品牌型"),
        },
        {
          value: "3",
          label: this.$t("message.数据结构型"),
        },
      ],
      classifyOptions: [
        // {
        //   value: "0",
        //   label: "无",
        //   disabled: true,
        // },
      ],//父级分类选项
      brandOptions: [
        {
          value: "0",
          label: "无",
          disabled: true,
        },
      ],
      classifyid: 0,
      type: "0",
      name: "",
      batchtag:"",
      img: "",
      belong: "",
      state:"",
      isseckill:true,
      extendid: "",
      parentid: "",
      sort: 0,
      brandid: "",
      createdate: "",
      createid: "",
      editdate: "",
      editid: "",
      isEditMode: true,
      isInit: true,
      isTempSwitch: true,
      isShowSwitch: true,
      showResourceStore: 0,
      showClassifyStore: 0,
      showShelvesStore: 0,
      deleteType: 0,
      showDateilDrawer: false,
      tableData: [],
      tableDataCarouse: [],
      targetRow: null,
      deleteDialogVisible: false,
      search: "",
      selectedBrandID: "",
      timer: "",
      d_img: "",
      d_jumpurl: "",
      d_sort: 0,
      d_isShowSwitch: true,
      displayclassify: false,

      // 筛选发送的数据条件
      sendData:{
        appID:188,
        filterConfig:{
          keyword:'',
          type:null
        },
        pageConfig:{
          page:1,
          pagesize:9999,
          pageStartIndex:0
        },
        sortConfig:{
          order:'',
          prop:''
        }
      },
      // tableData2:[],
      multipleSelection: [],//弹出框中选中并确认的
      searchContent:'',
      searchContentOnline: "",
      search:'',
      // 分页数据配置
      pageConfig: {
        pagesizeList: [20, 5, 10, 30, 40],
        pageSize: 10,
      },
      currentRow: null,
      flag:0,
      lengthc:0,
      filterData2:[],//显示栏最终选中的内容【分类下的产品管理】
      isarr:[],
      filternum:[],//原始数据
      parentname:'',//上级分类选中索引
      parentIndex:'',
      childIndex:'',
      pagechangeshow:false
    };
  },
  mounted: function () {
    topfixfunc();

    let self = this;
     self.$nextTick(function () {
      if (self.$refs.multipleTable.$el !== "undefined")
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 195;

      // 监听窗口大小变化
      
      window.onresize = function () {
        self.tableHeight =
          window.innerHeight - self.$refs.multipleTable.$el.offsetTop - 195;
      };
    });
    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
    self.refresh2()
  },
  watch: {},
  methods: {
    clearparentid(){
      this.parentname=''
      this.parentid=0
    },
    addInit(){
      // 判断filterdata2是否有值
      let len = this.filterData2.length;
          console.log(this.filternum,1234567812356897543235786543456786543)

      if(len > 0){
        if(this.parentid == ''){
          //option复选框
          this.filternum.forEach((item,index)=>{
            let obj = {
              value:index,
              classifyid:item.classifyid,
              // disabled:true,
              label:item.name,
              parentid:item.parentid
            }
            let i= this.filterData2.findIndex(it=>it.classifyid==item.parentid)
            if(i==-1){
              this.classifyOptions.push(obj)
            }else{
              this.classifyOptions = []
            }
          })
        }else{
          //拿到parentid + filternum
          let i = this.filternum.findIndex(it=>it.classifyid == this.parentid)
          if(i == -1){
            this.classifyOptions.push(obj)
          }else{
            this.classifyOptions = []
              console.log('选择了复选框，处理弹出框相同的数据')
          }
        }
      }else{
        //filternum = classifyOptions
          let init_arr = []
          // 去重
          this.filternum.forEach(item=>{
            if(!init_arr.includes(item.classifyid)){
              let obj = {
                value:index,
                classifyid:item.classifyid,
                // disabled:true,
                label:item.name,
                parentid:item.parentid
              }
              init_arr.push(obj)
            }
          })
          this.classifyOptions = init_arr;
      }
    },
    toggleSelection() {
      let self = this;
      self.$refs.multipleTable.clearSelection()
      setTimeout(() => {
        self.tableData2.forEach((row) => {
        if (row.ischoosed) {
          // if(this.multipleSelection.findIndex(it=>it.classifyid==row.classifyid)==-1){
          self.$refs.multipleTable.toggleRowSelection(row);
          // }
        }
      });
      }, 50);
    },
    onButtonClick(id) {
      this.flag=0
      let arr = []
      // 光存储，最后提交存储的内容 filterData2
      // 情况：弹出框：内容不为空选中的内容放到表单里 multipleSelection
              // 内容为空不放入
              // 选过的剔除掉，样式为选中状态
      if (id == 1) {
        // 有内容：判断是否与filterData2数组是否重叠，如重叠去重
        if(this.multipleSelection.length >0){
          let arr = []
            for (var i = 0; i < this.multipleSelection.length; i++) {
                if (!this.filterData2.includes(this.multipleSelection[i].classifyid)) {
                  this.multipleSelection[i].ischoosed = false;
                  arr.push(this.multipleSelection[i])
                  
                }
            }
            this.filterData2 = arr;
            console.log(this.filterData2,'sssss',this.filternum,'原数组')
            this.displayclassify = false;
        }else{
          // 无内容：不需要加入filterData2数组
          console.log('当前未选中')
          this.displayclassify = false;
        }
        // console.log('当前选中的内容',this.multipleSelection)
      } else {
        this.displayclassify = false;
        
      }
    },
     // 子组件调用的方法，分页模块
    paginationChange(pagesize, page, name) {
      this.pagechangeshow=false
      console.log(pagesize, page);
      console.log(this.multipleSelection);
      this.sendData.pageConfig.page =
        page != -1 ? page : this.sendData.pageConfig.page;
      this.sendData.pageConfig.pagesize =
        pagesize != -1 ? pagesize : this.sendData.pageConfig.pagesize;
        this.refresh2();
    },
    doSearch() {
      this.search = this.searchContent.toLowerCase();
    },
    getBooleanName(bool) {
      return commonUtil.getBooleanName(bool);
    },
    getClassifyTypeName(type) {
      return commonUtil.getClassifyTypeName(type);
    },
    // 上级分类触发事件
    ParentSelect(index){
      console.log(index)
      
      if(index !== ''){
        console.log(this.classifyOptions)
        // this.parentIndex = index;
        this.parentid = this.classifyOptions[index].classifyid;
        console.log(this.parentid)
        this.parentname = this.classifyOptions[index].label;
        
        // this.filterData2.forEach((item,index)=>{
        //     if(this.parentid == item.classifyid){
        //         this.childIndex = index;
        //       }else{
        //         this.childIndex = ''
        //       }
        //   })
        console.log(this.parentname,'上级分类触发事件')
        // this.refresh2()
        // this.init2()
      }else{
        this.parentIndex = ''
        // this.refresh2()
        // this.init2()
      }
    },
    // 更改
    initRefresh(){
      /**
     * 上级分类【显示全部】、子分类
     * 先 上级分类：
     * 1.选中 子分类去除包含的上级parentid
     * 2.未选中 显示全部
     * 先子分类
     * 1.选中 上级分类如选中子级分类内容=》弹出提示框并清楚上级内容
     * 
     */
      

      console.log(this.parentIndex,'sssp',this.childIndex)
      let data = []
      let arrdata = this.filternum
      if(this.parentIndex !='' && this.childIndex == ''){
        
        // 先 上级分类：
        arrdata.forEach((item,index)=>{
          if(this.parentid != item.classifyid){
            data.push(item);
          }
        })
        this.filternum = data;
      }
      // 先子分类
      //子分类有数据
      if(this.parentIndex != '' && this.childIndex != ''){
        if(this.childIndex == this.parentIndex){
            //弹出提示框
            this.$message('子分类中不能包含父分类！');
            this.parentname = ''
          }
      }
    },
    init2(){
      this.initRefresh()

          this.classifyOptions = []
          this.filternum.forEach((item,index)=>{
            if(item.classifyid==this.parentid){
              console.log(item,123467890)
              this.parentname=item.name
            }
            let obj = {
                value:index,
                classifyid:item.classifyid,
                // disabled:true,
                label:item.name,
                parentid:item.parentid
              }
             let i= this.filterData2.findIndex(it=>(it.classifyid==item.classifyid||item.type!==0))
             console.log(i)
             if(i==-1){
              this.classifyOptions.push(obj)
             }
          })
          // 去重classifyOptions
          // let arr2 = []
          // this.classifyOptions.forEach((item,index2)=>{
          //   if(!arr2.includes(item.parentid)){
          //     arr2.push(item);
          //   }
          // })
          // this.classifyOptions = arr2;

          console.log(this.classifyOptions,this.filternum,'数据111')
          this.filternum.forEach((any) => {
            any.editdate = commonUtil.formatDate(any.editdate);
          });
          this.toggleSelection();
    },
    refresh2(){
      // 关键字及和筛选条件的赋值
      this.sendData.filterConfig.keyword=this.search
      this.sendData.filterConfig.type=this.selectedTypeID
      rejecthttp(true,'post',"/manage/classify/getclassifylist",this.sendData,this,(doc)=>{
        changeflagCLOSED(doc,0,this)
        if(doc.data.Code == 'MSGKEY_OK'){
          this.pageConfig.total = doc.data.exData.datas;

          let arr = JSON.parse(JSON.stringify(doc.data.data));
          this.filternum = []
          // conslog
          arr.forEach((item,index)=>{
            if(this.classifyid != item.classifyid){
              this.filternum.push(item)
            }
          })
          let arr5 =[]
          this.filterData2.forEach(item=>{
              let c=arr.find(it=>it.classifyid!=item.classifyid)
              if(c){
                arr5.push(c)
              }
          })
          arr=arr5
          console.log(arr5,23456789,this.filterData2)
          this.pagechangeshow=true
          this.init2()
          this.initRefresh()

          // this.classifyOptions = []
          // this.filternum.forEach((item,index)=>{
          //   let obj = {
          //       value:index,
          //       classifyid:item.classifyid,
          //       // disabled:true,
          //       label:item.name,
          //       parentid:item.parentid
          //     }
          //     this.classifyOptions.push(obj)
          // })
          // // 去重classifyOptions
          // let arr2 = []
          // this.classifyOptions.forEach((item,index2)=>{
          //   if(!arr2.includes(item.parentid)){
          //     arr2.push(item);
          //   }
          // })
          // this.classifyOptions = arr2;

          // console.log(this.classifyOptions,this.filternum,'数据111')
          // this.filternum.forEach((any) => {
          //   any.editdate = commonUtil.formatDate(any.editdate);
          // });
          // this.toggleSelection();
        }
      })
    },
    handleSelectionChange(val){
      console.log(val,'选中的内容')
      this.multipleSelection = JSON.parse(JSON.stringify(val));
    },
    indexm(i){
      return (this.sendData.pageConfig.pagesize*(this.sendData.pageConfig.page-1)+1+i)
    },
    keyIndex(row) {
      return row.shelvesid;
    },
    // 排序的回调
    filterFunc(config) {
      // 获取点击的dom保存下来，等待翻页后继续留用
      // 获取dom元素
      // this.sendData.pageConfig.page = 1;
      // this.sendData.sortConfig.order = config.order;
      // this.sendData.sortConfig.prop = config.prop;
      // this.refresh2();
      // 保存排序的dom标签
      // this.clickDom=orderDom
    },
    // 将选中过的表单改为不可选状态
    isselected(row, index) {
      // console.log(row,'kkkjj')
      return !row.ischoosed;
    },
    addclassifyfunc() {
      this.displayclassify = true;
      this.refresh2()
      // this.toggleSelection()
    },
    goBack() {
      this.$router.go(-1); //返回上一层
    },
    arrtonum(arr){
            var res=0
            arr.forEach(i=>{
                res+=i
            })
            return res
        },
    doSave() {
      this.name=this.name.trim()
      if (!this.name) {
        this.$message({
          type: "error",
          message: this.$t("message.名称不能为空"),
        });
        return;
      }
      if (this.belong ==='') {
        this.$message({
          type: "error",
          message: this.$t("message.归属不能为空"),
        })
    }
      // this.batchtag=this.batchtag.trim()
      // if (!this.batchtag) {
      //   this.$message({
      //     type: "error",
      //     message: '批次标签不能为空',
      //   });
      //   return;
      // }
      this.isEditMode = false;
      let arrData = [];
      this.tableData.forEach((item) => {
        arrData.push({ shelvesid: item.shelvesid, sort: item.sort });
      });

      let addData = [];
      // editdate: "2021-08-04 20:05:58"
      // editid: 10000
      this.filterData2.forEach((item,index)=>{
        // delete item.editdate;
        // delete item.editid;
        item.editdate = 0;
        item.editid = 0;
        addData.push(item)
      })
      
      let sendObj = {
        info: {
          appid: this.appid,
          classifyid: this.classifyid,
          type: this.type,
          name: this.name,
          batchtag:this.batchtag,
          img: this.img,
          isshow: this.isShowSwitch ? "1" : "0",
          // istemp: this.isTempSwitch ? "1" : "0",
          sort: this.sort,
          belong: this.belong,
          state:this.state,
          isseckill:this.isseckill? 1 : 0,
          extendid: this.extendid ? parseInt(this.extendid) : 0,
          parentid: this.parentid ? parseInt(this.parentid) : 0,
          createdate: +new Date(),
          createid: 0,
          editdate: +new Date(),
          editid: 0,
          receivetype:this.arrtonum(this.receivetype)
        },
        carousels: this.tableDataCarouse,
        products: arrData,
        childclassifys:addData
      };
      if (this.isInit)
        rejecthttp(
          true,
          "post",
          "/manage/classify/addclassify",
          sendObj,
          this,
          (doc) => {
            changeflagCLOSED(doc, 1, this);
            if (doc.data.Code == "MSGKEY_OK") {
              // this.isEditMode = false;
            }
          }
        );
      // this.$http.post("/manage/classify/addclassify", sendObj).then((doc) => {
      //   // console.log(doc.data)
      //   if (doc.data.Code != "MSGKEY_OK") {
      //     this.$message({
      //       type: "error",
      //       message: doc.data.Message,
      //     });
      //   } else {
      //     this.$message({
      //       type: "success",
      //       message: doc.data.Message,
      //     });
      //     this.$router.go(-1); //返回上一层
      //   }
      // });
      else {
        rejecthttp(
          true,
          "post",
          "/manage/classify/updateclassify",
          sendObj,
          this,
          (doc) => {
            changeflagCLOSED(doc, 1, this);
            if (doc.data.Code == "MSGKEY_OK") {
              // this.isEditMode = false;
            }
          }
        );
        // this.$http
        //   .post("/manage/classify/updateclassify", sendObj)
        //   .then((doc) => {
        //     // console.log(doc.data)
        //     if (doc.data.Code != "MSGKEY_OK") {
        //       this.$message({
        //         type: "error",
        //         message: doc.data.Message,
        //       });
        //     } else {
        //       this.$message({
        //         type: "success",
        //         message: doc.data.Message,
        //       });
        //     }
        //   });
      }
    },
    doSaveDetail() {
      if (this.targetRow) {
        this.targetRow.img = this.d_img;
        this.targetRow.jumpurl = this.d_jumpurl;
        this.targetRow.isshow = this.d_isShowSwitch ? 1 : 0;
        this.targetRow.sort = this.d_sort;
      } else {
        let item = {
          img: this.d_img,
          jumpurl: this.d_jumpurl,
          isshow: this.d_isShowSwitch ? 1 : 0,
          sort: this.d_sort,
        };
        this.tableDataCarouse.push(item);
      }
      this.showDateilDrawer = false;
    },
    doShowResourceStore(type) {
      if (!this.isEditMode) return;
      this.showResourceStore = type;
    },
    onResourceStoreCallback(doc) {
      console.log(doc);
      if (doc) {
        if (this.showResourceStore == 1) this.img = doc.resourceID;
        else this.d_img = doc.resourceID;
        this.showResourceStore = 0;
      } else {
        this.showResourceStore = 0;
      }
    },
    numtoarr(num){
            var res=[],
            flag=1
            while(flag<=num){
                if(num&flag){
                    res.push(flag)
                }
                flag*=2
            }
            return res
        },
    refresh() {
      rejecthttp(
        true,
        "get",
        "/manage/brand/getbrandlist",
        {
          appid: "188",
        },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            console.log(doc.data);
            this.brandOptions = [];
            doc.data.data.forEach((any) => {
              let item = {
                value: any.brandid,
                label: any.name,
              };
              this.brandOptions.push(item);
            });
          }
        }
      );
      if (!this.classifyid) {
        return;
      }
      rejecthttp(
        true,
        "get",
        "/manage/classify/getclassifyinfo",
        {
          appid: "188",
          classifyid: this.classifyid,
        },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            pushdata(doc.data.exData.datas)
            console.log(doc.data);
            this.classifyid = doc.data.data.info.classifyid;
            this.name = doc.data.data.info.name;
            this.batchtag = doc.data.data.info.batchtag;
            this.img = doc.data.data.info.img;
            this.type = doc.data.data.info.type.toString();
            this.isShowSwitch = doc.data.data.info.isshow == "1" ? true : false;
            this.isTempSwitch = doc.data.data.info.istemp == "1" ? true : false;
            this.receivetype = this.numtoarr(doc.data.data.info.receivetype)
            console.log(this.receivetype)
            this.sort = doc.data.data.info.sort;
            this.createdate = commonUtil.formatDate(
              doc.data.data.info.createdate
            );
            this.createid = doc.data.data.info.createid;
            this.editdate = commonUtil.formatDate(doc.data.data.info.editdate);
            this.editid = doc.data.data.info.editid;
            this.belong = doc.data.data.info.belong;
            this.state = doc.data.data.info.state;
            this.isseckill = doc.data.data.info.isseckill== 1 ? true : false;
            console.log('查看this.belong',this.belong)
            this.extendid = doc.data.data.info.extendid.toString();
            this.parentid = doc.data.data.info.parentid.toString();
            this.tableData = doc.data.data.products;
            if (!this.tableData) this.tableData = [];
            this.tableDataCarouse = doc.data.data.carousels;
            if (!this.tableDataCarouse) this.tableDataCarouse = [];
            this.filterData2 = doc.data.data.childclassifys;
            this.refresh2()

          }
        }
      );
     
    },
    addChild() {
      this.ismulti = true;
      this.showClassifyStore = true;
    },
    addProduct() {
      this.ismulti = true;
      this.showShelvesStore = true;
    },
    editTarget(data) {
      this.targetRow = data;

      //赋值
      this.d_branddetailid = data.branddetailid;
      this.d_detailtypeid = data.detailtypeid;
      this.d_title = data.title;
      this.d_content1 = data.content1;
      this.d_content2 = data.content2;
      this.d_jumpurl = data.jumpurl;
      this.d_headImg = data.headimg;
      this.d_midImg = data.midimg;
      this.d_sort = data.sort;
      this.d_isShowSwitch = data.isshow == "1" ? true : false;
    },
    deleteTarget() {
      if (this.deleteType == 1) this.deleteCarouselTarget();
      else if(this.deleteType == 2) this.deleteProductlTarget();
      else this.delectChildProductTarget();
    },
    createCarouseTarget() {
      //清空值
      this.targetRow = null;
      this.d_img = "";
      this.d_jumpurl = "";
      this.d_isShowSwitch = true;
      this.d_sort = 0;

      this.showDateilDrawer = true;
    },
    editCarouseTarget(data) {
      this.targetRow = data;

      //赋值
      this.d_img = this.targetRow.img;
      this.d_jumpurl = this.targetRow.jumpurl;
      this.d_isShowSwitch = this.targetRow.isshow == 1 ? true : false;
      this.d_sort = this.targetRow.sort;
      this.showDateilDrawer = true;
    },
    deleteProductlTarget() {
      console.log(this.targetRow);
      let index = this.tableData.findIndex((item) => {
        if (item == this.targetRow) {
          return true;
        }
      });
      // this.$set(tableData,index,row);
      this.tableData.splice(index, 1);
      this.deleteDialogVisible = false;
    },
    delectChildProductTarget(){
      
      let index = this.filterData2.findIndex((item) => {
        if (item == this.targetRow) {
          return true;
        }
      });
      // this.$set(tableData,index,row);
      this.filterData2.splice(index, 1);
      this.deleteDialogVisible = false;
      console.log(this.targetRow,this.filterData2,index);

      // this.doSave()
    },
    deleteCarouselTarget() {
      console.log(this.targetRow);
      let index = this.tableDataCarouse.findIndex((item) => {
        if (item == this.targetRow) {
          return true;
        }
      });
      // this.$set(tableData,index,row);
      this.tableDataCarouse.splice(index, 1);
      this.deleteDialogVisible = false;
    },
    getTypeName(id) {
      let result = "未选择";
      this.typeOptions.forEach((item) => {
        if (parseInt(item.value) == parseInt(id)) return (result = item.label);
      });
      return result;
    },
    getBooleanName(bool) {
      return commonUtil.getBooleanName(bool);
    },
    getBrandName(id) {
      let result = "未选择";
      this.brandOptions.forEach((item) => {
        if (parseInt(item.value) == parseInt(id)) return (result = item.label);
      });
      return result;
    },
    getProductStateName(state) {
      return commonUtil.getProductStateName(state);
    },
    onStoreClick(doc) {
      this.timer = new Date().getTime();
      this.showShelvesStore = !this.showShelvesStore;
      if (this.ismulti) {
        if (doc.sel) {
          let nextIndex = this.tableData.length;
          doc.sel.forEach((element) => {
            this.$set(element, "classifyid", this.classifyid);
            this.$set(element, "sort", nextIndex);
            nextIndex++;
          });
          this.tableData = this.tableData.concat(doc.sel);
          this.showShelvesStore = 0;
        }
      } else {
      }
    },
    toTop(row) {
      commonUtil.setItemToTopForArray(this.tableData, row);
      this.reSort();
    },
    toUp(row) {
      this.tableData = [].concat(
        commonUtil.setItemToUpForArray(this.tableData, row)
      );
      this.reSort();
    },
    toDown(row) {
      this.tableData = [].concat(
        commonUtil.setItemToDownForArray(this.tableData, row)
      );
      console.log(this.tableData);
      this.reSort();
    },
    toBottom(row) {
      commonUtil.setItemToBottomForArray(this.tableData, row);
      this.reSort();
    },
    reSort() {
      let sort = 0;
      this.tableData.forEach((element) => {
        element.sort = sort;
        sort++;
      });
    },
    handleClose(done) {
      // 空函数, 防止dialog被不小心关闭
    },
    handleCloseDrawer(done) {
      this.$confirm(this.$t("message.确认关闭"))
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    filterNum() {
      if (this.filternum)
        return this.filternum.filter(
          (data) =>
            !this.search ||
            data.branddetailid
              .toLowerCase()
              .includes(this.search.toLowerCase()) ||
            data.title.toLowerCase().includes(this.search.toLowerCase()) ||
            data.content1.toLowerCase().includes(this.search.toLowerCase()) ||
            data.content2.toLowerCase().includes(this.search.toLowerCase()) ||
            data.jumpurl.toLowerCase().includes(this.search.toLowerCase()) ||
            data.classifyid
              .toString()
              .toLowerCase()
              .includes(this.search.toLowerCase())
        );
      else return [];
    },
  },
  created() {
    this.appid = this.$route.query.appid ? this.$route.query.appid : 0;
    if (this.$route.query.id) {
      this.classifyid = this.$route.query.id;
      this.isEditMode = this.$route.query.isEditMode ? true : false;
      this.isInit = false;
    }
    this.refresh();
    // this.refresh2()
  },
  computed: {
    filterData() {
      if (this.tableData)
        return this.tableData.filter(
          (data) =>
            !this.search ||
            data.branddetailid
              .toLowerCase()
              .includes(this.search.toLowerCase()) ||
            data.title.toLowerCase().includes(this.search.toLowerCase()) ||
            data.content1.toLowerCase().includes(this.search.toLowerCase()) ||
            data.content2.toLowerCase().includes(this.search.toLowerCase()) ||
            data.jumpurl.toLowerCase().includes(this.search.toLowerCase()) ||
            data.classifyid
              .toString()
              .toLowerCase()
              .includes(this.search.toLowerCase())
        );
      else return [];
    },
    tableData2() {
      let templist = [].concat(this.filterNum());
      templist = JSON.parse(JSON.stringify(templist));
      this.ischoosedList = [];
      for (let i = 0; i < templist.length; i++) {
        let item1 = templist[i];
        this.filterData2.forEach((item2,index2) => {
          if (item1.classifyid == item2.classifyid) {
            templist[i].ischoosed = true;
            console.log(templist[i]);
            console.log(templist[i].ischoosed);
            this.lengthc++
          } else if (item1.classifyid != item2.classifyid) {
            if (!templist[i].ischoosed) {
              templist[i].ischoosed = false;
            }
          }
        });
        // 与filterData2做对比，判断是否重复，重复选上
        console.log(this.parentid)
        if(item1.classifyid==this.parentid){
          templist.splice(i,1)
        }
      }
      return templist;
    },
  },
};
</script>

<style scoped>
.el-table /deep/ td {
  user-select: text !important;
}
.serch-box{
  margin-top: -15px;
}
/* .seek-box /deep/.serch{
  top:0 !important;
} */

.resource {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
}

.seek-box {
  position: absolute;
  width: 330px;
  height: 40px;
  top: -42px;
  right: 0px;
  z-index: 10;
}

.seek-box /deep/ .el-input__inner {
  height: 35px;
}
seek-main {
  width: 80%;
  height: 40px;
  font-size: 14px;
  color: #888;
  border: none;
}

.seek-icon {
  font-size: 28px;
  cursor: pointer;
  color: #303133;
  position: relative;
  top: 5px;
  margin-left: 0.1em;
}

.flex-b{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/products/ClassifyDetail.vue